export default "__VITE_ASSET__3dea1b04__"